import { redirect } from "react-router-dom";
import { getCache } from "../../util/Cache";

export const fetchGetLaporanPengaduanAll = async () => {
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    
    myHeaders.append("Authorization", key); 
    const url = process.env.REACT_APP_API_URL + "/lapor";    
    try {
        const response = await fetch(url,{
            method: 'GET',
            headers: myHeaders,
            redirect: 'follow'
        })

        const result = await response.json();
        return { status: result.status, data: result.data };

    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalahan pada server", data: [] };
    }
};

export const fetchGetLaporanPengaduanTeknik = async () => {
    let key = process.env.REACT_APP_API_KEY || '';
    var myHeaders = new Headers();
    myHeaders.append("Authorization", key);
    const url = process.env.REACT_APP_API_URL + "/lapor/teknik";
    const requestOptions = {
        method  : 'GET',
        headers : myHeaders,
        redirect: 'follow' as RequestRedirect  
    }
    try {
        const response = await fetch(url, requestOptions);
        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Error:', error);
        return { status: 500, message: "Terjadi kesalah pada server", data: [] }
    }
}